import { gql } from '@apollo/client';

export const CREATE_ACTION_PLAN_STATUS = gql`
  mutation createActionPlanStatus($input:create_action_plan_statusInput!) {
    createActionPlanStatus(input:$input){
      id
      name
      color
      sorting
    }
  }
`;

export const UPDATE_ACTION_PLAN_STATUS = gql`
  mutation updateActionPlanStatus($input: update_action_plan_statusInput!) {
    updateActionPlanStatus(input: $input) {
      sorting
      name
      id
      color
    }
  }
`;

export const DELETE_ACTION_PLAN_STATUS = gql`
  mutation removeActionPlanStatus($input: remove_action_plan_statusInput!) {
    removeActionPlanStatus(input: $input) {
      actionPlan {
        name
        id
      }
    }
  }
`;

export const PROFESSIONAL_CREATE_CLIENT = gql`
  mutation professionalCreateClient ($input: professional_create_clientInput!) {
    professionalCreateClient (input: $input) {
      success,
      message
    }
  }
`;

export const PROFESSIONAL_DELETE_CLIENT = gql`
  mutation professionalDeleteClient($input: professional_delete_clientInput!) {
    professionalDeleteClient(input: $input) {
      message
      success
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_ACTION_PLAN_STATUS = gql`
  mutation UpdateClientActionPlanStatus($clientId: ID!, $actionPlanStatusId: ID!) {
    updateClientActionPlanStatus(
      input: {clientId: $clientId, actionPlanStatusId: $actionPlanStatusId}
    ) {
      success
      message
    }
  }
`;

export const PROFESSIONAL_SEND_MESSAGE = gql`
  mutation professionalSendMessage ($input: inmail_professional_send_messageInput!) {
    professionalSendMessage(input:$input) {
      message
      success
    }
  }
`;

export const PROFESSIONAL_TWOFACTOR_QR = gql`
  mutation twoFactorQr($input: two_factor_qrInput!) {
    twoFactorQr(input: $input) {
      dataUrl
    }
  }
`;

export const PROFESSIONAL_CREATE_LOG = gql`
  mutation professionalCreateLogs ($input:professional_create_logsInput!) {
    professionalCreateLogs(input:$input) {
      id
      title
      content
      clientSummaryAndActions
      mainHealthProblemVasScore
      generalWellBeingVasScore
      energyLevelVasScore
    }
  }
`;

export const PROFESSIONAL_UPDATE_LOG = gql`
  mutation professionalUpdateLogs ($input:professional_update_logsInput!) {
    professionalUpdateLogs(input:$input) {
      id
      title
      content
      clientSummaryAndActions
      mainHealthProblemVasScore
      generalWellBeingVasScore
      energyLevelVasScore
    }
  }
`;

export const PROFESSIONAL_REMOVE_LOG = gql`
  mutation professionalDeleteLogs($input: professional_delete_logsInput!) {
    professionalDeleteLogs(input: $input) {
      success
      message
    }
  }
`;

export const PROFESSIONAL_CREATE_CLIENT_HEALTH_COMPLAINT_NOTES = gql`
  mutation createProfessionalClientHealthComplaintNotes($input: create_professional_client_health_complaint_notesInput!) {
    createProfessionalClientHealthComplaintNotes(input: $input) {
      id
      tags
      content
      clientId
      createdAt
      updatedAt
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_HEALTH_COMPLAINT_NOTES = gql`
  mutation professionalUpdateClientHealthComplaintNotes($input: professional_update_client_health_complaint_notesInput!) {
    professionalUpdateClientHealthComplaintNotes(input: $input) {
      id
      tags
      content
      clientId
      createdAt
      updatedAt
    }
  }
`;

export const PROFESSIONAL_ASSIGN_QUESTIONNAIRE_TO_CLIENT = gql`
  mutation assignQuestionnaireToClient($input: questionnaire_assign_questionnaireInput!) {
    assignQuestionnaireToClient(input: $input) {
      message
      success
    }
  }
`;

export const PROFESSIONAL_CREATE_TIMELINE_EVENT = gql`
  mutation professionalCreateTimelineEvent($input: professional_create_timeline_eventInput!) {
    professionalCreateTimelineEvent(input: $input) {
      id
      day
      month
      year
      client {
        id
        firstName
        familyName
      }
      content
      createdAt
      updatedAt
    }
  }
`;
export const PROFESSIONAL_UPDATE_TIMELINE_EVENT = gql`
  mutation professionalUpdateTimelineEvent($input: professional_update_timeline_eventInput!) {
    professionalUpdateTimelineEvent(input: $input) {
      id
      day
      month
      year
      client {
        id
        firstName
        familyName
      }
      content
      createdAt
      updatedAt
    }
  }
`;
export const PROFESSIONAL_DELETE_TIMELINE_EVENT = gql`
  mutation professionalDeleteTimelineEvent($input: professional_delete_timeline_eventInput!) {
    professionalDeleteTimelineEvent(input: $input) {
      message
      success
    }
  }
`;


export const PROFESSIONAL_CREATE_TREATMENT_ADVICE = gql`
  mutation professionalCreatePrescribedMedications($input: professional_create_prescribed_medicationsInput!) {
    professionalCreatePrescribedMedications(input: $input) {
      id
      content
      clientId
      createdAt
      updatedAt
    }
  }
`;
export const PROFESSIONAL_UPDATE_TREATMENT_ADVICE = gql`
  mutation professionalUpdatePrescribedMedications($input: professional_update_prescribed_medicationsInput!) {
    professionalUpdatePrescribedMedications(input: $input) {
      id
      content
      clientId
      createdAt
      updatedAt
    }
  }
`;
export const PROFESSIONAL_DELETE_TREATMENT_ADVICE = gql`
  mutation professionalDeletePrescribedMedications($input: professional_delete_prescribed_medicationsInput!) {
    professionalDeletePrescribedMedications(input: $input) {
      success
      message
    }
  }
`;

export const PROFESSIONAL_PIN_CONVERSATION = gql`
  mutation pinConversation($input: inmail_pin_conversationInput!) {
    pinConversation(input: $input) {
      success
    }
  }
`;

export const PROFESSIONAL_UNPIN_CONVERSATION = gql`
  mutation unpinConversation($input: inmail_unpin_conversationInput!) {
    unpinConversation(input: $input) {
      success
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_BIO = gql`
  mutation professionalClientUpdateBio($input: professional_cfs_update_bioInput!) {
    professionalClientUpdateBio(input: $input) {
      bio {
        id
        sex
        length
        weight
        clientId
        clientBioFemale {
          id
        }
        waistCircumference
        dateOfBirth
        isVegetarian
      }
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_SPECIALISTS = gql`
  mutation professionalClientUpdateSpecialists($input: cfs_professional_update_specialistsInput!) {
    professionalClientUpdateSpecialists(input: $input) {
      id
      specialists {
        id
        name
      }
      otherHealthProfessionals {
        id
        name
      }
    }
  }
`;

export const PROFESSIONAL_UPDATE_TIMELINETAB = gql`
  mutation professionalSetTimelineTab($input: professional_set_timeline_tabInput!) {
    professionalSetTimelineTab(input: $input) {
      id
      name
      color
    }
  }
`;

export const PROFESSIONAL_INVITE_COLLEAGUE = gql`
  mutation professionalAddColleague($input: professional_add_colleagueInput!) {
    professionalAddColleague(input: $input) {
      message
      success
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_CONTACT_DETAILS = gql`
  mutation professionalClientUpdateContactDetails($input: cfs_professional_update_contact_detailsInput!) {
    professionalClientUpdateContactDetails(input: $input) {
      personalContactDetail {
        id
        createdAt
        updatedAt
        __typename
        addressPlace
        addressNumber
        addressStreet
        addressCountry
        addressPostalCode
        telephoneNumber
        telephoneCountryCode
      }
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_VACCINATIONS = gql`
  mutation professionalClientUpdateVaccinations($input: cfs_professional_update_vaccinatinosInput!) {
    professionalClientUpdateVaccinations(input: $input) {
      vaccinations {
        id
        when
        vaccination {
          id
          name
        }
      }
    }
  }
`;

export const PROFESSIONAL_UPDATE_CLIENT_ALLERGIES = gql`
  mutation professionalClientUpdateAllergies($input: cfs_professional_update_allergiesInput!) {
    professionalClientUpdateAllergies(input: $input) {
      allergies {
        id
        allergy {
          id
          name
        }
      }
    }
  }
`;